<template>
	<div>
		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Selesai</h5>
			</template>
			<div v-if="data.conditionChecked">
				<h4 v-if="valid.includes(null)">Workorder lagi dibuat. Harap Menunggu...<br> Mohon jangan keluar dihalaman ini.</h4>

				
				<b-progress :value="value" :max="100" show-progress animated height="2rem">
					<b-progress-bar :value="value" >
						<span>Progress: <strong>{{ value }} / {{ 100 }}</strong></span>
					</b-progress-bar>
				</b-progress>
				<div  class="row mt-3 mb-3">
					<div class="col-6 fa-3x" v-for="(val, index) in valid">
						<h5 >
							<i class="fas fa-spinner fa-spin" v-if="val == 'Process'"></i>
							<i class="fa fa-check" v-else-if="val == true"></i> 
							<i class="fa fa-times-circle" v-else></i> 
							{{checklistDataInput[index]}}
						</h5>
						<button class="btn btn-warning" v-if="typeof val == 'boolean' && !val" @click="$emit('correctFailUpload' , index + 1)">Kirim Ulang Data</button>
					</div>
				</div>

				<br>
			</div>
			
			<table class="table table-borderless mt-4">
				<tbody>
					<tr>
						<td><h3>Nomor Work Order :</h3></td>
						<td><h3>{{data.form_code}}</h3></td>
					</tr>
					<tr>
						<td>Nama Konsumen :</td>
						<td>{{data.customer.name}}</td>
					</tr>
					<tr>
						<td>Tahun :</td>
						<td>{{data.customer_car.year}}</td>
					</tr>
					<tr>
						<td style="vertical-align:middle">Estimasi Selesai :</td>
						<td>
							<Datepicker style="padding-left:0;" :disabledDates="disabledDates" class="estimasi" :format="customFormatter" bootstrap-styling v-model="data.finishDate"></Datepicker>
						</td>
					</tr>
					<tr>
						<td colspan="2">Silahkan lanjut kebagian administrasi untuk melanjutkan proses penerimaan mobil.</td>
					</tr>
				</tbody>
			</table>

			<UploadCarImage 
				class="mt-3 pl-2 pr-2"
				@updateImage="updateImage"
				:form_code="data.form_code"
			/>

			<b-progress :value="value" :max="maxValue" show-progress animated height="2rem" v-if="(typeof value != 'object')">
				<b-progress-bar :value="value" >
					<span>Progress: <strong>{{ value }} / {{ maxValue }}</strong></span>
				</b-progress-bar>
			</b-progress>
		</panel>

		<div class="row">
			<div class="col-md-8 col-6">
			</div>
			<div class="col-md-4 col-6">
				<button type="button" class="btn btn-primary w-100 rounded" v-if="!skip" @click="updateWorkOrder(null)">Ke Estimator</button>
				<button type="button" class="btn btn-primary w-100 rounded" v-if="skip" :disabled="file.length == 0" @click="updateWorkOrder('skip')">Bikin Tanda Terima Baru</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import moment from 'moment'
	import Datepicker from 'vuejs-datepicker'
	import UploadCarImage from '../children/uploadCarImage.vue'
	import env from '@/env'

	export default {
		components: {
			Multiselect,
			Datepicker,
			UploadCarImage
		},
		data () {
			return {
				finishDate: new Date(),
				disabledDates: {
					to: new Date(new moment().format("Y-MM-DD"))
				},
				checklistDataInput : ['Data Input' , 'Kondisi Accu dan KM' , 'Depan' , 'Kiri' , 'Belakang' , 'Kanan' , 'Atap' , 'Checklist Barang'],
				allowNewWorkOrder : false,
				file : [],
				value : null,
				maxValue : 1
			}
		},
		props: ['page', 'data', 'checklistSettings', 'merek', 'carType', 'skip' , 'valid' , 'value'],
		mounted () {
			
		},
		methods: {
			updateImage (image) {
				this.file = image
				console.log(image)
			},
			async uploadAllImage() {
				let image = []

				this.loading = true
				let length = this.file.length
				this.maxValue = length
				this.value = 0

				for(var i = 0 ; i < this.file.length ;  i++) {
					let vm = this
					try {
						// console.log(this.file[i])
						if(!this.file[i].type.includes('image')) throw new Error('Not An Image File Type');
						// console.log(this.file[i][0])
						let resp = await fetch(URL.createObjectURL(this.file[i]))

						let blob = await resp.blob()

						let file = new File([blob], 'test.png');
						console.log(file)


						let formData = new FormData()

						formData.append('work_order', file)

						let response = await vm.$http.post(env.urlStart + '/api/v1/workorder/image', formData, {headers : {"Content-Type":'multipart/form-data'}})

						image.push(response.data.data.filename)

						console.log(image)
						if(this.value == length) {
							this.loading = false
						}
						else {
							this.value++
						}
					}
					catch(err) {
						this.$store.dispatch('triggerAlert' , [false , err])
						console.log(err)
						return false
						
					}
					
				}
				
				return image
			},
			customFormatter : function(date){
				return moment(date).format('DD MMM YYYY');
			},
			updateWorkOrder : async function (skip) {
				try {
					let data = {}

					data.condition = {}
					data.condition.imageList = await this.uploadAllImage()
					if(!data.condition.imageList) return;

					data.finishDate = new moment(this.data.finishDate ? this.data.finishDate : null).format('Y-MM-DD')
					
					this.$http.patch('/api/v1/workorder/' + this.data.form_code , {data : data})
					.then((resp) => {
						this.$store.state.lastData = null
						this.$store.dispatch('triggerAlert' , [true , 'Work Order Telah Berhasil Disimpan!'])
						if(!skip) {
							if(this.data.serviceType != 'Beli Sparepart')
								this.$router.push('/estimator/estimator-application/' + this.data.form_code)
							else {
								this.$router.push('/estimator/estimator-parts/' + this.data.form_code)
							}
						}
							
						else
							window.location.reload()

					})
					.catch((err) => {
						console.log(err)
					})
				}
				catch(err) {
					console.log(err)
				}
			}
		}
	}
</script>

<style scoped>
	.table td, p {
		font-size: 15px !important;
	}
</style>

<style>
	.estimasi .form-control[readonly] {
		background-color: #fff;
	}

	.estimasi .input-group {
		padding-left : 0;
	}
</style>

